export enum BackEndJobStatus {
  Unknown = 0,
  Waiting = 1,
  Running = 2,
  Complete = 3,
  RequestStop = 4
}

export const BackEndJobStatusMapping: Record<BackEndJobStatus, string> = {
  [BackEndJobStatus.Unknown]: 'Unknown',
  [BackEndJobStatus.Waiting]: 'Waiting',
  [BackEndJobStatus.Running]: 'Running',
  [BackEndJobStatus.Complete]: 'Complete',
  [BackEndJobStatus.RequestStop]: 'Request for stop'
};
